import {
  getDocs,
  collection,
  getFirestore,
  getDoc,
  doc,
  QueryDocumentSnapshot,
  DocumentSnapshot,
  DocumentData,
} from "firebase/firestore";
import { CodeError } from './actions';
import { DbCollection } from "../constants/db";
import { SurveyTemplate, SurveyTemplatDbData } from "../models/SurveyTemplates";
import { showTranslatedMessage } from "../store/reducers/snacks";
import { SurveyTemplatesActions } from "../store/reducers/surveyTemplates/list";
import { SelectedSurveyTemplateActions } from "../store/reducers/surveyTemplates/selected";
import { AppDispatch } from "../store/store";



function fromDbDoc(dbDoc: QueryDocumentSnapshot<DocumentData>): SurveyTemplate;
function fromDbDoc(dbDoc: DocumentSnapshot<DocumentData>): SurveyTemplate | null;
function fromDbDoc(dbDoc: QueryDocumentSnapshot<DocumentData> | DocumentSnapshot<DocumentData>): SurveyTemplate | null {
  const data = dbDoc.data() as SurveyTemplatDbData;
  return {
    ...data,
    ID: dbDoc.id,
    updatedAt: data.updatedAt ? data.updatedAt.toDate().toISOString() : '',
  };
}

/**
 * Lists all survey templates for a partner.
 * @param partnerID - The ID of the partner whose templates to retrieve.
 */
const list = (partnerID: string) => async (dispatch: AppDispatch) => {
  dispatch(SurveyTemplatesActions.startLoading());

  try {
    const db = getFirestore();
    const collectionRef = collection(db, DbCollection.PARTNERS, partnerID, DbCollection.SURVEY_TEMPLATES);
    const snapshot = await getDocs(collectionRef);
    const templates: SurveyTemplate[] = snapshot.docs.map((d) => fromDbDoc(d));
    
    dispatch(SurveyTemplatesActions.setList(templates));
    dispatch(SurveyTemplatesActions.stopLoading());
    return templates;
  } 
  catch (e) {
    const error = e as CodeError | Error;
    console.error("Failed to list survey templates", error);
    dispatch(SurveyTemplatesActions.setError(error.message));
    dispatch(showTranslatedMessage({
      variant: "error",
      messageKey: "survey_templates.list.error",
      moreInfo: error.message,
    }));
    return [];
  }
};

/**
 * Gets a survey template by ID.
 * @param partnerID - The ID of the partner whose template to retrieve.
 * @param templateID - The ID of the template to retrieve.
 */
const getById = (partnerID: string, templateID: string) => async (dispatch: AppDispatch) => {
  dispatch(SurveyTemplatesActions.startLoading());
  try {
    const db = getFirestore();
    const docRef = doc(db, DbCollection.PARTNERS, partnerID, DbCollection.SURVEY_TEMPLATES, templateID);
    const snapshot = await getDoc(docRef);
    const template = fromDbDoc(snapshot);
    dispatch(SelectedSurveyTemplateActions.setSelected(template));
    dispatch(SurveyTemplatesActions.stopLoading());
    return template;
  } catch (e) {
    const error = e as CodeError | Error;
    console.error("Failed to get survey template by ID", error);
    dispatch(SurveyTemplatesActions.setError(error.message));
    return null;
  }
};

const SurveyTemplatesController = {
  list,
  getById,
};

export default SurveyTemplatesController;
